import * as actionTypes from './actionTypes';




// reducers
export const setSourceCRS = (crs) => ({ type: actionTypes.ADV_SET_SOURCE_CRS, crs: crs })
export const setTargetCRS = (crs) => ({ type: actionTypes.ADV_SET_TARGET_CRS, crs: crs })
